/**
 * @generated SignedSource<<af3965b1a7b6dd3e455d58381f22c802>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type FileViewerFragment$data = {
  readonly contentLength: number;
  readonly contentType: string;
  readonly downloadUrl: Url;
  readonly name: string;
  readonly " $fragmentType": "FileViewerFragment";
};
export type FileViewerFragment$key = {
  readonly " $data"?: FileViewerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileViewerFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileViewerFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentLength",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadUrl",
      "storageKey": null
    }
  ],
  "type": "FileBrowserFileEntry",
  "abstractKey": null
};

(node as any).hash = "e5273ff49131fd306dca706f801694df";

export default node;
